"use client";

import { useGetNews } from "@/components/parts/admin/news/api";
import { Separator } from "@/components/ui/separator";
import NewsCard from "./newsCard";

const NewsSection = () => {
  const { data } = useGetNews("page=1&limit=6");
  const newsData = data?.data.items;

  return (
    <section className="bg-[#E8EFF6]">
      <div className="container py-7">
        <div className="flex items-center gap-4">
          <h3 className="text-primary-700 font-semibold mb-7 md:text-3xl text-xl whitespace-nowrap">
            Berita Terbaru
          </h3>
          <div className="flex-1 mb-7">
            <Separator className="bg-primary-700" />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 place-items-center">
          {newsData
            ?.slice(0, 3)
            .map((item) => (
              <NewsCard
                category={item.categoryArticle.name}
                key={item.id}
                id={item.id}
                imageUrl={item.imageUrl}
                date={item.date}
                title={item.title}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
